import {useState} from 'react'
import {  useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import BasicSelector from '../components/ui/BasicSelector.jsx'
import { useSelector,useDispatch } from 'react-redux'
import { setLang } from '../store/langSlice.js'
import {useUser} from '../hooks/'

// ICONS 
import {MdLanguage} from 'react-icons/md'
import {VscAccount} from 'react-icons/vsc'
import {MdNotificationsNone,MdSupport} from 'react-icons/md'

const UserBar = ({tenantUsername,tenant}) => {
    const [t,i18n] = useTranslation('global')
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {getUser} = useUser();
    const _token = localStorage.getItem('token');
    const user = useSelector((state) => state.auth).user;
    const currentCompany = useSelector((state) => state.currentCompany);
    const currentBranch = useSelector((state) => state.currentBranch);
    
    // Lang List
    const [openListLang,setOpenListLang] = useState(false);
    const listLangHandler = tenant?.languages?.map(language => ({
        label: language.langCode === 'ar' ? t('language.ar') : language.langCode === 'en' ? t('language.en') : (language.langName || language.langCode),
        value: language.langCode
    }))
    const langSelected = useSelector((state)=>state.lang)
    const normalizedSelectedLabel = langSelected?.value === 'ar'
        ? t('language.ar')
        : langSelected?.value === 'en'
            ? t('language.en')
            : langSelected?.label;
    const selectedLangLabel = listLangHandler?.find((item) => item.value === langSelected?.value)?.label || normalizedSelectedLabel || t('common.selectLanguage');
    const normalizeLang = (value) => String(value || '').toLowerCase().startsWith('ar') ? 'ar' : 'en';

    const logoutHandler = () => {
        console.log('logout')
        navigate(`/${tenantUsername}/logout`)
    }
    const onSelectedLangHandler = (lang) => {
        const normalized = normalizeLang(lang?.value);
        if (normalized === langSelected?.value) return;
        const normalizedLabel = normalized === 'ar' ? t('language.ar') : t('language.en');
        i18n.changeLanguage(normalized)
        dispatch(setLang({label: normalizedLabel, value: normalized}))
        saveCentralSelection(
            currentCompany?.value || user?.company_id,
            currentBranch?.value || user?.branch_id,
            normalized
        );
    }


    const onSelectedUserList = (item) => {
        // console.log(value)
        switch (item.value) {
            case 'logout':
                logoutHandler()
                break;
            default:
                break;
        }
    }

    // User List
    const [openListUser,setOpenListUser] = useState(false);
    const userList = [
        {label:t('user.myAccount'),value:'myAccount'},
        {label:t('user.changePassword'),value:'changePassword'},
        {label:t('user.logout'),value:'logout'},
    ]
    const saveCentralSelection = async (selectedCompanyId, selectedBranchId, selectedLang) => {
        if (!user?.tenant_id) return;
        const token = localStorage.getItem('token');
        if (!token) return;
        try {
            await axios.put(
                `${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`,
                {
                    tenantId: user.tenant_id,
                    scope: 'header-selection',
                    data: {
                        selectedCompanyId,
                        selectedBranchId,
                        selectedLang
                    }
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                    validateStatus: () => true
                }
            );
        } catch (error) {
        }
    };
    return (
        <div className='flex items-center justify-between md:justify-end gap-2 text-xs  w-full '>

            <BasicSelector 
                border={false}
                listItem={userList}
                label={getUser?.name }
                defaultValue={getUser?.name }
                openList={openListUser}
                setOpenList={setOpenListUser}
                withChangeLabel={false}
                onSelected={onSelectedUserList}
                >
                    <VscAccount size={16}/> 
                </BasicSelector>

            <div className='text-slate-200'>|</div>
            
            <BasicSelector withArrow={false}  border={false} > <MdNotificationsNone size={18} /></BasicSelector>
            
            <div className='text-slate-200'>|</div>
            
            <Link  className='px-3' target='_blank'  to={`${process.env.REACT_APP_WEB_APPS_BASE_URL}/${tenantUsername}/token/${_token}`}> <MdSupport size={16} /> </Link>
            
            <div className='text-slate-200'>|</div>

            <BasicSelector 
                border={false}
                label={selectedLangLabel}
                openList = {openListLang}
                setOpenList = {setOpenListLang}
                onSelected={onSelectedLangHandler}
                defaultValue = {langSelected.value}
                listItem={listLangHandler} >
                <MdLanguage size={16}/>
            </BasicSelector>
        </div>
    )
}

export default UserBar
